export const handleKeyDown = (e, keycodes, callback) => {
  console.log(e);
  if (keycodes.includes(e.keyCode)) {
    e.preventDefault();
    callback();
  }
}